var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"绑定钉钉","width":"480px","custom-class":"dialog","visible":_vm.visible,"before-close":() => _vm.$emit('hide')}},[_c('div',{staticStyle:{"padding":"0 16px 16px","min-height":"370px"}},[(_vm.visible)?_c('LoginDingtalk',{attrs:{"type":"bind","text1":"使用钉钉扫一扫","text2":"绑定钉钉"},on:{"ok":_vm.onBindSuccess}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }